<div class="container product-listing-page">
  <div class="row g-0 gx-lg-0 breadcrumb-wrapper">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <!-- <div style="float: right;">
        Dealer Name: {{dealerLen[0].division_name}}
      </div> -->
      <app-breadcrumb *ngIf="showBreadCrumb"></app-breadcrumb>
    </div>

  </div>
  <div class="row filter-wrapper g-0" id="productlist">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mobile-response">

      <div class="row g-0">
        <!--Awadhesh filter left-->
        <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 d-lg-block mobile-view-filter mt-2"
          style="border-right: 1px solid #CDCED5;" [ngClass]="{'show-filters': isFilterOpen}">
          <app-filter  *ngIf="!unbxFilter" ></app-filter>
          <app-unbox-filter *ngIf="unbxFilter"></app-unbox-filter>



        </div>
        <!--sort-mobile-view-->
        <!-- <div class="card sort-mobile-view d-lg-none p-2 mt-3">
          <div class="filter-title">
            <div class="title">
              <a href="javascript:void(0)" class="filter-text-color">SORT</a>
              <a href="javascript:void(0)" class="ms-auto view-more d-lg-none" id="sort_id"
                (click)="closeSort()">CLOSE</a>
            </div>
          </div>
          <ul class="mt-2">
            <li>Low to High</li>
            <li>High to Low</li>
          </ul>
        </div> -->
        <!--sort-mobile-view-->
        <!--Awadhesh list right-->
        <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9">
          <div class="d-flex align-items-center">
            <!--tablet filter text-->
            <div class="md-filter d-none d-md-flex d-lg-none">
              Filter <span>11</span>
              <img [src]="environment1 + 'images/new-images/dropdown.svg'" alt="dropdown" loading="lazy">
            </div>
            <div class="filters ps-lg-3 p-0">
          <h1 *ngIf="!unbxFilter"> {{breadcrumbdata[breadcrumblen-1]?.label?.replace("-"," ") | uppercase}} - {{rowlimit}} Vehicles found</h1>
          <h1 *ngIf="unbxFilter"> {{unbxSearchValue | uppercase}} - {{productList?.length == 1 ? productList?.length :rowlimit}} Vehicles found</h1>
            </div>
            <div class="ms-auto short-by ps-3 pe-3 position-relative d-none d-md-flex" *ngIf="!disableSort">
              Sort by

              <div class="sort-filter ps-4 position-relative active">
                <span class="">Price : </span>
                <select class="form-select" (change)="onFilterChange($event,'')" [(ngModel)]="sortingType">
                  <option [value]="item" *ngFor="let item of sortList">{{item}}</option>
                </select>
              </div>
            </div>

          </div>
          <div class="item-wrapper" style="border-top: 1px solid #CDCED5;;">
            <!--filter list-->
            <span class="d-flex" style="flex-wrap: wrap;">
              <div class="filter-list d-md-block" *ngFor="let item of filterShowList">
                <div class="filter-item">
                  <span *ngIf="item.event != 'OSP'">
                    {{item.event}}
                  </span>
                  <span *ngIf="item.event != 'OSP'" class="close" (click)="clickToremoveFilter(item)"></span>
                </div>
              </div>
            </span>
            <!--product list-->
            <div class="product-list pb-3" (scroll)="onScroll()">
              <div class="row g-3">
                <ng-container *ngIf="productList?.length == 0 && !productLoaded ;else productTemplate">
                  <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4"
                    *ngFor="let item of skeletonService.generateFake(6);let i = index;">
                    <div class="poduct-item">
                      <div class="img-wrapper" style="display: block;z-index: 0;">
                        <ngx-skeleton height="230px"></ngx-skeleton>
                      </div>
                      <div class="cv-name text-ellipsis">
                        <ngx-skeleton height="19px"></ngx-skeleton>
                      </div>
                      <div class="price">
                        <ngx-skeleton height="19px"></ngx-skeleton>
                      </div>
                      <div class="rating">
                        <ngx-skeleton height="19px"></ngx-skeleton>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <ng-template #productTemplate>
                  <ng-container *ngIf="productList?.length !== 0 && productLoaded">
                    <ng-container *ngFor="let row of list;let id = index">
                      <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                        <div class="poduct-item">
                          <div class="img-wrapper" style="overflow: hidden;">
                            <a target="_blank" [routerLink]="redirect(row.sub_lob,row.lob_seo,row.ppl_seo,row.model,row.id)" (click)="clevertapPDP(row)">
                              <img *ngIf="row?.images[0]?.image_url" alt=" {{row.model}}" src="{{row?.images[0]?.image_url}}"
                              style="cursor: pointer;" class="img-fluid" loading="lazy"
                               />
                            </a>
                           </div>
                          <!-- <div class="img-slide-wrapper">
                            <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
                              <div ngxSlickItem *ngFor="let slide of row.imgData" class="slide">
                                <div class="slick-custom-height">
                                  <a [routerLink]="redirect(row.sub_lob,row.lob_seo,row.ppl_seo,row.model,row.id)"  (click)="clevertapPDP(row)">
                                    <img style="cursor: pointer;" src="{{ slide.image_url }}" loading="lazy"
                                     alt="{{row.model}}">
                                  </a>
                                </div>
                              </div>
                            </ngx-slick-carousel>
                          </div> -->
                          <div class="d-flex align-items-center tagf">
                            <span class="badge bg-primary" *ngIf="row.is_new_launch==true"> Trending Product </span>
                            <div class="like ms-auto">
                              <button style="width: 24px; height: 24px; border: none;background-color: transparent;"
                                (click)="clickToAddWishlist(row.id)">
                                <span *ngIf="!row.wishlist">
                                  <img [src]="environment1 + 'images/new-images/heart.svg'" alt="heart" loading="lazy">
                                </span>
                                <span *ngIf="row.wishlist">
                                  <img [src]="environment1 + 'images/new-images/fillHeart.svg'" alt="fill Heart" loading="lazy">
                                </span>
                              </button>
                            </div>
                          </div>
                          <div class="cv-name text-ellipsis cursor">
                            <a target="_blank" style="color: black; text-decoration: none;"  [routerLink]="redirect(row.sub_lob,row.lob_seo,row.ppl_seo,row.model,row.id)" (click)="clevertapPDP(row)">
                              {{row.model}}
                            </a>
                          </div>
                          <div class="price" *ngIf="row.price_range">
                            {{row.price_range | currency:'INR':'symbol':'4.0-0'}} <span class="ex-show ps-1">Ex-showroom
                            </span>
                          </div>
                          <div class="price" *ngIf="!row.price_range">
                            <span>Please contact to Dealer.</span>
                          </div>
                          <div class="rating">
                            <ngx-stars [readonly]="true" [customStarIcons]="heartUrls" [color]="'#FDC602'"
                              [initialStars]="row.rating" [size]="5"></ngx-stars>
                          </div>
                          <div class="book-now">
                            <button type="button"
                              class="btn btn-primary text-ellipsis btn-lg btn-grad-primary btn-brand w-100"
                              data-toggle="tooltip" data-placement="top" title="Click here for Booking"
                              (click)="checkAmcData(row)">Book Now at {{row.down_payment |
                              currency:'INR':'symbol':'4.0-0'}}</button>
                          </div>
                        </div>
                      </div>
                      <div class="plp-configure-wrapper pt-5 pb-5"
                        *ngIf="((id + 1 ) % 9) == 0 || (id < 8 && id == (list?.length-1) && list?.length !== 0) ">
                        <div class="row">
                          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <h2 style="color: white;font-size: 24px;">Not sure which CV to buy?</h2>
                            <p class="mb-4">Let us help you find the perfect CV for your application</p>
                            <button class="btn btn-primary btn-grad-primary ps-5 pe-5 btn-height button-txt-desktop"
                            data-toggle="tooltip" data-placement="top" title="Click here to Build your own vehicle"
                              (click)="callConfigurator()" [routerLink]="'/configurator-home'">Build your own vehicle</button>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                  <!-- && !showLoader -->
                  <ng-container *ngIf="productList?.length == 0 && productLoaded ">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 empty-states">
                      <img [src]='environment1 + "assets/images/no_product_found.svg"' loading="lazy">
                      <h3>
                        No product found
                      </h3>
                      <div class="desc">
                        The product you were looking for couldn’t be found. Explore all <br />
                        products to see more commercial vehicles.
                      </div>
                      <div class="mt-4">
                        <button class="btn btn-primary btn-grad-primary btn-brand ps-4 pe-4"
                        data-toggle="tooltip" data-placement="top"  title="Click here to Explore all products"
                          (click)="exploreVehicle()">Explore all products</button>
                      </div>
                    </div>
                  </ng-container>
                </ng-template>

              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<!--user exprience review-->
<ng-container *ngIf="isUserLoggedIn">
  <span class="aside-tag" (click)="getReview()">
    <img [src]="environment1 + 'images/new-images/chat.svg'" alt="chat" loading="lazy">  <span>
      Help us to improve
    </span>
  </span>
  <span hidden class="aside-tag" id="feedbackBtn" data-bs-toggle="modal" data-bs-target="#exprience-review-modal">
    <img [src]="environment1 + 'images/new-images/chat.svg'" alt="chat" loading="lazy">
    <span>
      Help us to improve
    </span>
  </span>
</ng-container>
<span class="aside-tag" *ngIf="!this.isUserLoggedIn" (click)="redirectLogin()">
  <img [src]="environment1 + 'images/new-images/chat.svg'" alt="chat" loading="lazy">
  <span>
    Help us to improve
  </span>
</span>

<!--user exprience review modal-->
<div class="modal fade user-exprience-review-modal" id="exprience-review-modal" data-bs-backdrop="static"
  data-bs-keyboard="false" tabindex="-1" aria-labelledby="exprience-review-modalLabel" aria-hidden="true">
  <div class="modal-dialog modal-right modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exprience-review-modalLabel">Share your feedback</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body" *ngIf="!isReviewSubmitted">
        <form [formGroup]="feedBackForm">
          <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
              <label class="form-label mend">How was your Browsing experience ?</label>
              <div class="emoji-radio">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="Browsing" formControlName="Browsing" id="Browsing1"
                    value="1">
                  <label class="form-check-label" for="Browsing1">😣</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="Browsing" formControlName="Browsing" id="Browsing2"
                    value="2">
                  <label class="form-check-label" for="Browsing2">😕</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="Browsing" formControlName="Browsing" id="Browsing3"
                    value="3">
                  <label class="form-check-label" for="Browsing3">😐</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="Browsing" formControlName="Browsing" id="Browsing4"
                    value="4">
                  <label class="form-check-label" for="Browsing4">🙂</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="Browsing" formControlName="Browsing" id="Browsing5"
                    value="5">
                  <label class="form-check-label" for="Browsing5">😃</label>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
              <label class="form-label mend">Did you find what you were searching on our website?</label>
              <div class="plane-radio">
                <div class="row">
                  <div class="col-6">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="searching" formControlName="searching"
                        id="searching1" value="1">
                      <label class="form-check-label" for="searching1">Yes</label>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="searching" formControlName="searching"
                        id="searching2" value="0">
                      <label class="form-check-label" for="searching2">No</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
              <label class="form-label mend">Did you like the design pages & layout?</label>
              <div class="plane-radio">
                <div class="row">
                  <div class="col-6">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="design" formControlName="design" id="design1"
                        value="1">
                      <label class="form-check-label" for="design1">Yes</label>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="design" formControlName="design" id="design2"
                        value="0">
                      <label class="form-check-label" for="design2">No</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
              <label class="form-label mend">How likely are you to recommend our website to someone
                else?</label>
              <div class="plane-radio">
                <div class="row row-cols-5 gx-3">
                  <div class="col">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="recommend" formControlName="recommend"
                        id="recommend1" value="1">
                      <label class="form-check-label" for="recommend1">1</label>
                    </div>
                  </div>
                  <div class="col">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="recommend" formControlName="recommend"
                        id="recommend2" value="2">
                      <label class="form-check-label" for="recommend2">2</label>
                    </div>
                  </div>
                  <div class="col">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="recommend" formControlName="recommend"
                        id="recommend3" value="3">
                      <label class="form-check-label" for="recommend3">3</label>
                    </div>
                  </div>
                  <div class="col">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="recommend" formControlName="recommend"
                        id="recommend4" value="4">
                      <label class="form-check-label" for="recommend4">4</label>
                    </div>
                  </div>
                  <div class="col">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="recommend" formControlName="recommend"
                        id="recommend5" value="5">
                      <label class="form-check-label" for="recommend5">5</label>
                    </div>
                  </div>
                  <div class="col-12 d-flex"
                    style="text-transform: uppercase; color: #666C84; font-weight: 700;font-size: 10px;  line-height: 14px;">
                    Not likely <div class="ms-auto">Extremely likely</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
              <label class="form-label mend">Tell us what can be improved</label>
              <textarea class="form-control"
              (keydown)="notAllowSpace($event)"
               formControlName="improvement" placeholder="Tell us what can be improved"
                rows="4" maxlength="300"></textarea>
            </div>

          </div>
        </form>
      </div>
      <div class="modal-footer justify-content-start" *ngIf="!isReviewSubmitted">

        <button type="button" class="btn btn-primary btn-grad-primary btn-comment w-100 pt-2 pb-2"
        data-toggle="tooltip" data-placement="top" title="Please Submit your FeedBack"
          (click)="submitFeedback()">Submit</button>

      </div>

      <!--thanks user exprience review-->
      <div class="review-thank" *ngIf="isReviewSubmitted">
        <div class="content-area">
          <div class="img">
            <img [src]="environment1 + 'images/new-images/messageBig.svg'" alt="message" loading="lazy">

          </div>
          <div class="content">
            <h4>Review Submitted- Thank you!</h4>
            <p>Your feedback is important to us and will help us improve our product/service.</p>
            <div class="action-cta">
              <button type="button" class="btn  btn-primary btn-grad-primary close-btn" data-bs-dismiss="modal"
                aria-label="Close">Close</button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
<div class="sticky-filter d-flex gap-3 d-lg-none mobile-z-index" *ngIf="isBottomhide" style="z-index: 1000;">
  <a href="javascript:void(0)" class="view-more" (click)="openSort()" *ngIf="!disableSort">
    <img [src]="environment1 + 'images/new-images/sort.svg'" alt="sort" loading="lazy">
    SORT</a>
  <a href="javascript:void(0)" class="view-more" (click)="toggleFilters()"><img [src]="environment1 + 'images/new-images/filter.svg'" alt="filter" loading="lazy">
    Filters</a>
</div>
<!--Sort modal in mobile view-->

<div class="modal sort-mobile-view" id="sortModal" tabindex="-1" aria-labelledby="sortModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-sm modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title" id="sortModalLabel">Sort</div>
        <a href="javascript:void(0)" role="button" data-bs-dismiss="modal" (click)="closeSort()">CLOSE</a>
      </div>
      <div class="modal-body">
        <ul>
          <li><a (click)="onFilterChange('Low To High','')">Low to High</a></li>
          <li><a (click)="onFilterChange('High To Low','')">High to Low</a></li>
        </ul>
      </div>
    </div>
  </div>
</div>
<button hidden id="booking_amcbtn" data-toggle="tooltip" data-placement="top" title="Click here for Booking"  data-bs-toggle="modal" data-bs-target="#booking_amc" ></button>
<div class="amcModal model">
  <div class="modal fade" id="booking_amc"  data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="booking_amcLabel" aria-hidden="true" >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="d-flex justify-content-end">
          <button type="button" class="btn-close m-1" data-bs-dismiss="modal" (click)="closeModal()" aria-label="Close"></button>
        </div>
        <div class="modal-body" style="overflow: unset !important;">

          <div *ngIf="currentStep === 1">
            <div class="text-center">
              <div class="d-flex justify-content-center">
                <img [src]='environment1 + "assets/images/success.svg"' alt="">
              </div>
              <h3>Congratulations</h3>
              <p>You are eligible for AMC plans. Secure your vehicle now.</p>
            </div>
            <div class="row d-flex">
              <div class="col-12 col-lg-6 mb-2">
                <button type="button" class="btn btn-outline-primary btn-grad-outline-primary btn-brand btn-lg w-100"  data-bs-dismiss="modal" aria-label="Close" (click)=" bookNow('')">
                  Continue without AMC
                </button>
              </div>
              <div class="col-12 col-lg-6">
                <button type="button" class="btn btn-primary btn-lg btn-grad-primary btn-brand w-100" (click)="nextStep(false)">
                  Select an AMC plan
                </button>
              </div>
            </div>
          </div>

          <div *ngIf="currentStep === 2">
            <div class="d-flex justify-content-between align-items-center" style="color: #307FE2; font-size: 20px; font-weight: 700; line-height: 30px; text-align: center;">
              <h6>AMC/FMS Enquiry for New Vehicle</h6>
            </div>
            <div class="modal-body" style="overflow: unset !important;">
              <form [formGroup]="form">
                <div class="mt-2">
                  <div class="row mt-1">
                    <div class="col-12 col-sm-6 mb-4">
                      <label class="form-label">Model</label>
                      <input type="text" maxlength="45" class="form-control" placeholder="Model name" formControlName="model" [(ngModel)]="bookingData.model" >
                      <!--  -->
                      <div *ngIf="form.get('model')?.invalid && (form.get('model')?.dirty || form.get('model').touched)">
                        <small class="text-danger" *ngIf="form.get('model').errors?.required">Model is required.</small>
                        <small class="text-danger" *ngIf="form.get('model').errors?.maxlength">Model name cannot exceed 45 characters.</small>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 mb-2">
                      <label class="form-label">Number of Vehicles</label>
                      <input type="text" maxlength="45" (change)="numberofVehicleEvent($event)"
                       class="form-control" placeholder="Vehicle" formControlName="vehicles">
                      <div *ngIf="form.get('vehicles').invalid && (form.get('vehicles').dirty || form.get('vehicles').touched)">
                        <small class="text-danger" *ngIf="form.get('vehicles').errors?.required">Number of vehicles is required.</small>
                        <small class="text-danger" *ngIf="form.get('vehicles').errors?.max">Number of vehicles cannot exceed 99.</small>
                        <small class="text-danger" *ngIf="form.get('vehicles').errors?.min">Number of vehicles minimum 1.</small>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-1">
                    <div class="col-12 col-sm-6 mb-2">
                      <label class="form-label">Application</label>
                      <select class="form-select" formControlName="application" (change)="terrainAMCData($event)">
                        <option value="" selected disabled>Select Application...</option>
                        <option *ngFor="let application of aplicationAmcData" [ngValue]="application">{{ application.display_application }}</option>

                      </select>
                      <div *ngIf="form.get('application').invalid && (form.get('application').dirty || form.get('application').touched)">
                        <small class="text-danger" *ngIf="form.get('application').errors?.required">Application is required.</small>
                      </div>
                      <div *ngIf="terrainvalue === true && terraindaata == false ">
                        <small class="text-danger" *ngIf="terrainvalue === true"> AMC for this combination is not available, Please select another application.</small>
                      </div>
                      <div *ngIf="terraindaata === true ">
                        <small class="text-danger" *ngIf="terrainvalue === true && terraindaata == true ">This is a special application. Please contact your nearest dealer for suitable AMC.</small>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 mb-2">
                      <label class="form-label">Terrain</label>
                      <select class="form-select" formControlName="terrain" (change)="onTerrainChange($event)">
                        <option value="" selected disabled>Select terrain...</option>
                        <option *ngFor="let terrain of terrainData" [value]="terrain">{{ terrain }}</option>
                      </select>
                      <div *ngIf="form.get('terrain').invalid && (form.get('terrain').dirty || form.get('terrain').touched)">
                        <small class="text-danger" *ngIf="form.get('terrain').errors?.required">Terrain is required.</small>
                      </div>
                    </div>
                  </div>
                  <div class="row" style="margin-top: 35px;"  *ngIf="selectedTerrain && display == true && terrainvalue==false">
                    <div class="col-12 col-sm-6 mb-2">
                      <div class="slider-container">
                        <div class="d-flex justify-content-between" *ngIf="isHCV == true">
                          <label for="rangeSlider1" class="chasis_no" style="color: #666C84;">Annual running hours (in Hrs)</label>
                          <span style="color: navy;">{{annualRunningHours | number: '1.0-0'}} hrs</span>
                        </div>
                        <div class="d-flex justify-content-between" *ngIf="isHCV == false">
                          <label for="rangeSlider1" class="chasis_no" style="color: #666C84;">Annual running KMS (in Km)</label>
                          <span style="color: navy;">{{annualRunningHours | number: '1.0-0'}} KMS</span>
                        </div>
                        <ngx-slider class="mt-5" [(value)]="annualRunningHours" [options]="annualRunningHoursOptions" formControlName="range1" (valueChange)="onAnnualRunningHoursChange($event)"></ngx-slider>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 mb-2">
                      <div class="slider-container">
                        <div class="d-flex justify-content-between">
                          <label for="rangeSlider2" class="chasis_no" style="color: #666C84;">Duration of AMC</label>
                          <span style="color: navy;">{{amcDuration / 12}} Years</span>
                        </div>
                        <ngx-slider class="mt-5" [(value)]="amcDuration" formControlName="range2" [options]="amcDurationOptions" (valueChange)="onAmcDurationChange($event)"></ngx-slider>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <div class="row d-flex mt-3">
                <div class="col-12 col-lg-6 mb-2">
                  <button type="button" *ngIf="terrainvalue === true" class="btn btn-outline-primary btn-grad-outline-primary btn-brand btn-lg w-100"  data-bs-dismiss="modal" aria-label="Close" (click)=" bookNow('')">
                    Continue without AMC
                  </button>
                </div>
                <div class="col-12 col-lg-6">
                  <div *ngIf="selectedTerrain && invalidReq">
                    <small class="text-danger">AMC for this combination is not available, Please select another application.</small>
                  </div>
                  <button type="button" *ngIf="(datadismiss == true) && (bookingData.lob == 'HCV Const' || bookingData.lob == 'HCV Cargo'||bookingData.lob == 'LCV' || bookingData.lob == 'MCV Trucks' || bookingData.lob == 'ICV Trucks') "   [disabled]="form.invalid || invalidReq"  class="btn btn-primary btn-lg btn-grad-primary btn-brand w-100" (click)="nextStep(true)" >
                    Suggest an AMC plan
                  </button>

                  <button type="button" data-bs-dismiss="modal"   [disabled]="form.invalid || invalidReq"  class="btn btn-primary btn-lg btn-grad-primary btn-brand w-100" (click)="goToamc(true)" *ngIf="datadismiss == false">
                    Suggest an AMC plan
                  </button>
                </div>
              </div>
            </div>

          </div>
            <!-- Step 3: AMC Plan -->
           <div *ngIf="currentStep === 3">
            <h2>Hello {{userData?.first_name}},</h2>
            <p class="subtitle">
              Based on your customer need, choice of vehicle, application, and related details, the following combination of value-added services is recommended:
            </p>

            <div class="services-table">
              <div class="table-header">
                <span class="header-item">Product</span>
                <span class="header-item">Price/yr</span>
                <span class="header-item">Number of CV</span>
                <span class="header-item">Duration (Yrs)</span>
                <span class="header-item" style="margin: 0px 0px 0px 62px;">Total Price</span>
                <span class="header-item" *ngIf="isHCV == true" style="text-align: right;
    margin: -16px -400px;" >Annual Hrs</span>
                <span class="header-item" *ngIf="isHCV == false" style="text-align: right;
    margin: -16px -400px;">Annual KM</span>
              </div>

              <div class="service-item" *ngFor="let service of amcDataArray">
                <div class="service-icon-name">
                  <!-- <img [src]="service.icon" [alt]="service.name"> -->
                  <img  [src]="getPlanImage(service.plan)"  onerror="this.src='../../../assets/images/default_amc.png'"
                  alt="{{ service.plan }}"
                  class="plan-icon" />

                  <!-- <img src="../../../assets/images/{{ service.amc_fms_plan?.plan?.toLowerCase().replace(/plan/gi, '').trim() }}.png" alt="{{ service.amc_fms_plan.plan }}" class="plan-icon" /> -->
                  <span class="service-name">{{ service.plan }}</span>
                  <!-- <span class="info-badge" *ngIf="service.hasInfoBadge">i</span> -->
                </div>

                <!-- Price per year with currency formatting -->
                <span class="service-price">
                  {{ service.price_per_year | currency:'INR':'symbol':'4.0-0' }}
                </span>

                <!-- Number of CVs (assuming 'numberOfCV' exists) -->
                <span class="service-cv">{{ service.number_of_chassis}}</span>

                <!-- Contract tenure in years -->
                <span class="service-tenure">{{ service['contract years'] }}</span>
                <span class="service-tenure" *ngIf="isHCV == false">{{ service.yearly_contract_km}}</span><!-- hr add krnas -->
                <span class="service-tenure" *ngIf="isHCV == true" >{{ service.yearly_contract_hours}}</span>

                <!-- Total price calculation: price_per_year * contract years -->
                <span class="service-total"
                      style="font-size: 16px; font-weight: 700; line-height: 24px; text-align: right; color: #0A0A5F; margin: -27px -517px -2px;">
                  {{ ((service.price_per_year * (service['contract years'] || 1) ) * service.number_of_chassis) | currency:'INR':'symbol':'4.0-0' }}
                </span>
              </div>
            </div>

            <div class="total-section">
              <div class="total-row" style="font-size: 16px; font-weight: 700; line-height: 24px; text-align: right; color: #0A0A5F;margin: 0 24px 0 10px;">
                <span>Total</span>
                <!-- <span>₹{{ totalAmount | number: '1.2-2' }}</span> -->
                <span>  {{ calculateTotalAmount(amcDataArray) | currency:'INR':'symbol':'4.0-0' }}</span>
              </div>
            </div>


            <div class="action-buttons">
              <button class="secondary-button"  data-bs-dismiss="modal" (click)="goToamc(false)">Make my own plan</button>
              <button class="primary-button"(click)=" bookNow('',true)" data-bs-dismiss="modal" >Continue Booking with VAS</button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

